import React,{useRef,useState} from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import * as XLSX from 'xlsx';

import {ResetDriverData,isNull} from "../../../components/common/Common";

function DriverSearchEmptyResult({varDRMode}) {
  let admin_idx = 0;
  if(!isNull(localStorage.getItem("adminIdx"))) admin_idx = Number(localStorage.getItem("adminIdx"));

  //excel 파일 
  const fileRef = useRef();
  const [varExcelProgress,setExcelProgress] = useState(false);

  //EXCEL--------------------------------------------------------------------------------------
  //엑셀파일을 선택하기
  const onUploadExcelHandler = (e) => {
    fileRef.current.click();
  }
  //엑셀파일을 읽어오기
  const onSelectedFileHandler =  (e) => {
    const fileBox = fileRef.current;
    if(fileBox.value === "" || !fileBox.files) return false;
    setExcelProgress(true);
    const file = fileBox.files[0];
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e) => {
      if (!e.target) {
        setExcelProgress(false);
        return;
      } 
      console.log(e.target.result);
      const bufferArray = e.target.result;
      const fileInformation =  XLSX.read(bufferArray, {
        type: 'buffer',
        cellText: false,
        cellDates: true,
      });
      const sheetName = fileInformation.SheetNames[0];
      const rawData = fileInformation.Sheets[sheetName];
      const datas = XLSX.utils.sheet_to_json(rawData);
      console.log(datas);
      if(datas?.length === 0) {
        setExcelProgress(false);
        alert('읽어들일 정보가 존재하지 않습니다. 다른 파일을 선택하세요.'); return false;
      } 
      ReadExcelFileData(datas);
    };
  }
  //읽어드린 엑셀파일정보 재가공
  const ReadExcelFileData = async (datas) => {
    let sendArray = [];
    let existDriverArray = [];
    let registerDriverArray = [];
    console.log(datas);
    for(var i=0; i < datas.length; i++) {
      let sendData = ResetDriverData(datas[i]);
      if(isNull(sendData['mem_pwd'])) {
        setExcelProgress(false);
        alert('드라이버를 추가할려면 비밀번호가 반듯이 존재해야 합니다.');
        return false;
      }
      console.log(sendData);
      //운전자, 거래처
      if(!isNull(sendData['mem_id'])) {
        await axios.post(`${process.env.REACT_APP_HOST}/_get_driver_exceldata`,sendData).then((res) => {
          const datas = res.data;
          if(datas.retvalue === 1) {
            registerDriverArray.push(sendData['mem_name']);
            sendData['dr_reg_idx'] = admin_idx;
            sendArray.push(sendData);
          } else {
            existDriverArray.push(`${sendData['mem_name']}(${sendData['mem_id']})`);
          }
        });
      }
    }
    RegisterExcelFileData(sendArray,registerDriverArray,existDriverArray);
  }
  //회원등록
  const RegisterExcelFileData = async (sendArray,registerDriverArray,existDriverArray) => {
    const registerDrivers = registerDriverArray.join(',');
    const existDrivers = existDriverArray.join(',');
    let smessage = `기사정보를 등록하였습니다.\n새로 등록된 드라이버 : ${registerDrivers}`;
    if(existDriverArray?.length > 0) smessage += `\n이미 존재한 드라이버 : ${existDrivers}`;

    for(var i=0; i < sendArray.length; i++) {
      const sendData = {dataInfo:sendArray[i]};
      const res = await axios.post(`${process.env.REACT_APP_HOST}/_register_member`,sendData);
      console.log(i,res);
    }
    setExcelProgress(false); 
    alert(smessage);
    window.location.reload(); //리로드 페이지
  }
  //EXCEL--------------------------------------------------------------------------------------

  return (
    <div className="main-box" style={{marginTop:"30px"}}>
      <div className="btn-between">
        <div>
          {varDRMode===0?null:<button onClick={(e)=>onUploadExcelHandler(e)} className="btn line">EXCEL 읽어오기</button>}
          <input type="file" ref={fileRef} onChange={(e)=>onSelectedFileHandler(e)} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{display:"none"}}/>
          {varDRMode===0 && varExcelProgress?<span style={{marginLeft:"20px"}}>작업중...</span>:null}
        </div>
        <div>
          {varDRMode===0?null:<Link to={`/Admin/DriverDetail/1/0`} className="btn-danger">기사등록</Link>}
        </div>
      </div>
    </div>
  );
}

export default DriverSearchEmptyResult;